/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misty_Steep_Haddock_GripInputs */

const fr_misty_steep_haddock_grip = /** @type {(inputs: Misty_Steep_Haddock_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

/**

* @param {Misty_Steep_Haddock_GripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const misty_steep_haddock_grip = /** @type {((inputs?: Misty_Steep_Haddock_GripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misty_Steep_Haddock_GripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_misty_steep_haddock_grip(inputs)
});